<template>
	<div class="d-flex justify-content-center m-d-20">
		<div class="f-semi f-14 f-c-black m-r-8">Status</div>
		<div class="d-flex" v-if="typeNotaTransaksi">
			<div class="badge color-red" v-if="transaksi.detail_transaksi.status_bayar === 0 && transaksi.detail_transaksi.lunas === 0">Belum Bayar</div>
			<div class="badge color-red" v-if="transaksi.detail_transaksi.status_bayar === 1 && transaksi.detail_transaksi.lunas === 0">Belum Lunas</div>
			<div class="badge color-green" v-if="transaksi.detail_transaksi.status_bayar === 1 && transaksi.detail_transaksi.lunas === 1">Lunas</div>
		</div>
		<div class="d-flex" v-if="typeNotaTransaksiSnapclean">
			<div class="badge color-red" v-if="transaksi.detail_transaksi.status_lunas === 0">Belum Lunas</div>
			<div class="badge color-red" v-if="transaksi.detail_transaksi.status_lunas === 2">Belum Bayar</div>
			<div class="badge color-green" v-if="transaksi.detail_transaksi.status_lunas === 1">Lunas</div>
		</div>
		<div class="d-flex" v-if="typeNotaTopup">
			<div class="badge color-red" v-if="transaksi.detail_transaksi.lunas === 0">Belum Bayar</div>
			<div class="badge color-green" v-if="transaksi.detail_transaksi.lunas === 1">Lunas</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOTagihanStatusLunas",
	props: {
		transaksi: Object,

		typeNotaTransaksi: Boolean,
		typeNotaTopup: Boolean,
		typeNotaTransaksiSnapclean: Boolean,
	}
}
</script>